// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types'; 
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import environment from '../../../environment';
import { Helmet } from 'react-helmet';
import TopBanner from '../../new-order/components/TopBanner/TopBanner';
  
import TopHomeSearch from '../elements/TopHomeSearch/TopHomeSearch';
import HowItWorks from '../elements/HowItWorks/HowItWorks';
import FeaturedCards from '../elements/FeaturesCards/FeaturesCards';
import WaysToPay from '../elements/WaysToPay/WaysToPay';
import StatisticCard from '../elements/StatisticCard/StatisticCard';
import HappyCustomers from '../elements/HappyCustomers/HappyCustomers';
import CarouselPressNews from '../elements/CarouselPressNews/CarouselPressNews';
import BottomHomeSearch from '../elements/BottomHomeSearch/BottomHomeSearch';
import BannerCarousel from '../elements/BannerCarousel/BannerCarousel';

import coverUSImg from '../../../assets/img/home_meta_US_cover.png';
import coverPEImg from '../../../assets/img/home_meta_PE_cover.png';
import coverCOImg from '../../../assets/img/home_meta_CO_cover.png';

import style from './NewHome.scss';

import type { LocaleState } from '../../locale/duck'; 
import type { LocalValuesState } from '../../local-values/duck';

type Props = {   
  +goToRedirect: (route: string) => void;
  +locale: LocaleState;
  +localValues: LocalValuesState;
};

type State = { 
};

 
const messages = defineMessages({
  US: {
    title: {
      id: 'home.document.title.US',
    },
    description: {
      id: 'home.document.description.US',
    },
  },
  PE: {
    title: {
      id: 'home.document.title.PE',
    },
    description: {
      id: 'home.document.description.PE',
    },
  },
  BR: {
    title: {
      id: 'home.document.title.BR',
    },
    description: {
      id: 'home.document.description.BR',
    },
  },
  MX: {
    title: {
      id: 'home.document.title.MX',
    },
    description: {
      id: 'home.document.description.MX',
    },
  },
  CO: {
    title: {
      id: 'home.document.title.CO',
    },
    description: {
      id: 'home.document.description.CO',
    },
  },
  CL: {
    title: {
      id: 'home.document.title.CL',
    },
    description: {
      id: 'home.document.description.CL',
    },
  },
  default: {
    title: {
      id: 'home.document.title',
    },
    description: {
      id: 'home.document.description',
    },
  },
  titlePartOne: {
    id: 'home.mainBlock.title.partOne',
  },
  titlePartTwo: {
    id: 'home.mainBlock.title.partTwo',
  },
  titlePartThree: {
    id: 'home.mainBlock.title.partThree',
  },
  titlePartFour: {
    id: 'home.mainBlock.title.partFour',
  },
  titlePartFive: {
    id: 'home.mainBlock.title.partFive',
  },
  titlePartFiveCO: {
    id: 'home.mainBlock.title.partFive.CO',
  },
  titleUserBoxOne: {
    id: 'home.userTypeBoxes.titlePartOne',
  },
  titleUserBoxTwo: {
    id: 'home.userTypeBoxes.titlePartTwo',
  },
  titleUserBoxThree: {
    id: 'home.userTypeBoxes.titlePartThree',
  },
  warranty: {
    titleOne: {
      id: 'newOrder.scrap.howWorks.warranty.title.one',
    },
    titleTwo: {
      id: 'newOrder.scrap.howWorks.warranty.title.two',
    },
    titleThree: {
      id: 'newOrder.scrap.howWorks.warranty.title.three',
    },
    button: {
      id: 'newOrder.scrap.howWorks.warranty.button',
    },
  },
});

const countriesImages = {
  US: coverUSImg,
  PE: coverPEImg,
  CO: coverCOImg,
};

export default class NewHome extends Component<Props, State> {
  render() { 
    const {goToRedirect, locale, localValues} = this.props;

    const description = this.context.intl.formatMessage((messages[locale.domainCountry] || messages.default).description);
    const title = this.context.intl.formatMessage((messages[locale.domainCountry] || messages.default).title);
    const baseUrl = environment.baseUrl[locale.domainCountry || 'US'];
    const coverImg = countriesImages[locale.domainCountry || 'US']; 
    return (
      <Fragment>
        <Helmet meta={[
          { name: 'description', content: description },
          { property: 'og:image', content: `${baseUrl}${coverImg}` },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { name: 'twitter:title', content: title },
          { name: 'twitter:twitter:image', content: `${baseUrl}${coverImg}` },
          { name: 'twitter:twitter:description', content: description },
        ]}>
          <title>{title}</title>
          <style type="text/css">{`
            #sirena_button {
              display: block!important;
            }
          `}</style>
        </Helmet>
        <TopBanner step="product"
                   localValues={localValues}
                   locale={locale}/>
        <div className={style.homeWrap}>
          <TopHomeSearch  
            goToRedirect={goToRedirect}
            locale={locale}/>
          <BannerCarousel />
          <HowItWorks 
            locale={locale}
          />
          <FeaturedCards />
          <WaysToPay />
          <StatisticCard />
          <HappyCustomers />
          <CarouselPressNews />
          <BottomHomeSearch
            goToRedirect={goToRedirect}
            locale={locale}/>
        </div>

      </Fragment>
    );
  }
}

NewHome.propTypes = { 
  goToRedirect: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
};

NewHome.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/home/components/NewHome.jsx